// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Spinner" (9980:37317). Do not edit.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const spinnerContract = {
    component: 'Spinner',
    nodeId: '9980:37317',
    section: '[Web] Primitives',
    // Components a variant instantiates, with the variant keys used.
    // Where one of these carries the component's own paint rather than
    // a glyph, the classes below describe only what is left — Checkbox
    // swaps a whole box here.
    composes: [{ component: 'Spinner', variants: ['variant=default'] }],
    stateAxis: null,
    // The shape, for a component that is one rather than has one.
    // Rendered with `currentColor`, so its ink comes from `icon`
    // like every other glyph in the package.
    glyph: {
        name: 'progress-activity',
        nodeId: '9980:37310',
        width: 24,
        height: 24,
        paths: [
            {
                d: 'M8.12035 21.213C6.90457 20.6885 5.84289 19.9724 4.93534 19.0647C4.02762 18.1571 3.31151 17.0954 2.787 15.8796C2.26233 14.6639 2 13.3676 2 11.9909C2 10.6142 2.26217 9.32095 2.78651 8.11104C3.31086 6.9013 4.02689 5.84265 4.9346 4.93509C5.84232 4.02754 6.90416 3.31143 8.12011 2.78676C9.33606 2.26225 10.6294 2 12 2C12.3128 2 12.5769 2.10756 12.7922 2.32269C13.0073 2.53798 13.1148 2.80203 13.1148 3.11484C13.1148 3.42765 13.0073 3.6917 12.7922 3.90699C12.5769 4.12212 12.3128 4.22968 12 4.22968C9.84693 4.22968 8.01361 4.98647 6.50004 6.50004C4.98647 8.01361 4.22968 9.84693 4.22968 12C4.22968 14.1529 4.98647 15.9862 6.50004 17.5C8.01361 19.0135 9.84693 19.7703 12 19.7703C14.1529 19.7703 15.9862 19.0135 17.5 17.5C19.0135 15.9864 19.7703 14.1531 19.7703 12C19.7703 11.6872 19.8779 11.4231 20.093 11.2079C20.3083 10.9927 20.5724 10.8852 20.8852 10.8852C21.198 10.8852 21.462 10.9927 21.6773 11.2079C21.8924 11.4231 22 11.6872 22 12C22 13.3706 21.7377 14.6639 21.2132 15.8799C20.6886 17.0958 19.9725 18.1577 19.0649 19.0654C18.1574 19.9731 17.0987 20.6891 15.889 21.2135C14.679 21.7378 13.3858 22 12.0091 22C10.6324 22 9.33614 21.7377 8.12035 21.213Z',
            },
        ],
    } as FigmaGlyph,
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [] as readonly ContractDisagreement[],
    textStyleIds: [],
    props: {
        variant: { kind: 'enum', values: ['on-button', 'default'] },
    },
    variants: {
        'variant=default': {
            container: 'w-[1.5rem] h-[1.5rem]',
            label: '',
            icon: 'text-primary-default',
            disabled: '',
            visited: '',
            box: '',
            parts: {
                'progress-activity': 'w-[1.25rem] h-[1.25rem]',
            },
            glyphs: {
                'progress-activity': {
                    name: 'progress-activity',
                    nodeId: '9980:37310',
                    width: 20,
                    height: 20,
                    paths: [
                        {
                            d: 'M6.12035 19.213C4.90457 18.6885 3.84289 17.9724 2.93534 17.0647C2.02762 16.1571 1.31151 15.0954 0.787004 13.8796C0.262335 12.6639 0 11.3676 0 9.99093C0 8.61425 0.262171 7.32095 0.786514 6.11104C1.31086 4.9013 2.02689 3.84265 2.9346 2.93509C3.84232 2.02754 4.90416 1.31143 6.12011 0.786759C7.33606 0.262253 8.62936 0 10 0C10.3128 0 10.5769 0.107563 10.7922 0.322691C11.0073 0.537982 11.1148 0.802032 11.1148 1.11484C11.1148 1.42765 11.0073 1.6917 10.7922 1.90699C10.5769 2.12212 10.3128 2.22968 10 2.22968C7.84693 2.22968 6.01361 2.98647 4.50004 4.50004C2.98647 6.01361 2.22968 7.84693 2.22968 10C2.22968 12.1529 2.98647 13.9862 4.50004 15.5C6.01361 17.0135 7.84693 17.7703 10 17.7703C12.1529 17.7703 13.9862 17.0135 15.5 15.5C17.0135 13.9864 17.7703 12.1531 17.7703 10C17.7703 9.68719 17.8779 9.42314 18.093 9.20785C18.3083 8.99272 18.5724 8.88516 18.8852 8.88516C19.198 8.88516 19.462 8.99272 19.6773 9.20785C19.8924 9.42314 20 9.68719 20 10C20 11.3706 19.7377 12.6639 19.2132 13.8799C18.6886 15.0958 17.9725 16.1577 17.0649 17.0654C16.1574 17.9731 15.0987 18.6891 13.889 19.2135C12.679 19.7378 11.3858 20 10.0091 20C8.63238 20 7.33614 19.7377 6.12035 19.213Z',
                        },
                    ],
                },
            } as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [],
        },
        'variant=on-button': {
            container: 'w-[1.5rem] h-[1.5rem]',
            label: '',
            icon: 'text-content-on-primary',
            disabled: '',
            visited: '',
            box: '',
            parts: {} as Record<string, string>,
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {} as Record<string, string>,
            composes: [{ component: 'Spinner', variants: ['variant=default'] }],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    glyph: FigmaGlyph
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
